import { WizardConfig } from '@/components/common/mass-edit-wizard/config';
import { SemenDto } from '@/services/semen-service/types';

export const massEditSemenConfig: WizardConfig = {
  fields: {
    dateReceived: {
      label: 'Date Received',
      type: 'date',
      mapValue: (formValue: Date) => formValue.toISOString(),
    },
    sire: {
      label: 'Sire',
      type: 'object',
      mapValue: (formValue: any, row: SemenDto) => {
        if (!formValue) return undefined;
        return {
          sireId: formValue.id,
          sire: {
            ...row.sire,
            id: formValue.id,
            name: formValue.name || row.sire?.name || '',
          },
        };
      },
    },
    owner: {
      label: 'Owner',
      type: 'object',
      mapValue: (formValue: any, row: SemenDto) => {
        if (!formValue) return undefined;
        const ownerId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          ownerId,
          ownerName:
            typeof formValue === 'string' ? row.ownerName : formValue.name,
        };
      },
    },
    colCode: {
      label: 'Col Code',
      type: 'string',
    },
    storageLocation: {
      label: 'Storage Location',
      type: 'object',
      mapValue: (formValue: any, row: SemenDto) => {
        if (!formValue) return undefined;
        const storageLocationId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          storageLocation: {
            ...row.storageLocation,
            id: storageLocationId || '',
            name:
              typeof formValue === 'string'
                ? row.storageLocation?.name || ''
                : formValue.name,
          },
        };
      },
    },
    quantityReceived: {
      label: 'Quantity Received',
      type: 'number',
      mapValue: (formValue: number) => String(formValue),
    },
    cane: {
      label: 'Cane',
      type: 'string',
    },
    naab: {
      label: 'NAAB',
      type: 'string',
    },
    sex: {
      label: 'Sex',
      type: 'number',
    },
    sexed: {
      label: 'Sexed',
      type: 'boolean',
      mapValue: (formValue: 'Yes' | 'No') => formValue === 'Yes',
      formatValue: (value: any) => {
        if (value === true) return 'Yes';
        if (value === false) return 'No';
        return String(value);
      },
    },
    cssCertified: {
      label: 'CSS Stamped',
      type: 'number',
      formatValue: (value: any) => {
        if (value === 100000001) return 'Yes';
        if (value === 100000000) return 'No';
        return String(value);
      },
    },
    export: {
      label: 'Export',
      type: 'number',
    },
    center: {
      label: 'Center',
      type: 'string',
    },
    shortName: {
      label: 'Short Name',
      type: 'string',
    },
    quantity: {
      label: 'Quantity',
      type: 'number',
      mapValue: (formValue: number) => String(formValue),
    },
    quantityToShip: {
      label: 'Quantity to Ship',
      type: 'number',
      mapValue: (formValue: number) => String(formValue),
    },
    soldTo: {
      label: 'Sold To',
      type: 'string',
    },
    sortStatus: {
      label: 'Sort Status',
      type: 'number',
      formatValue: (value: any) => {
        if (value === 100000000) return 'Rejected';
        return String(value);
      },
    },
    comment: {
      label: 'Comment',
      type: 'string',
    },
    critical: {
      label: 'Critical',
      type: 'number',
      formatValue: (value: any) => {
        if (value === 100000000) return 'Critical';
        return String(value);
      },
    },
    storageStartDate: {
      label: 'Storage Start Date',
      type: 'date',
      mapValue: (formValue: Date) => formValue.toISOString(),
    },
    secondaryOwner: {
      label: 'Secondary Owner',
      type: 'string',
    },
    cost: {
      label: 'Cost',
      type: 'number',
      mapValue: (formValue: number) => String(formValue),
    },
    shipment: {
      label: 'Shipment',
      type: 'object',
      mapValue: (formValue: any) => {
        if (!formValue) return undefined;
        const shipmentId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return shipmentId ? { shipmentId } : undefined;
      },
    },
    semenType: {
      label: 'Semen Type',
      type: 'string',
    },
    units: {
      label: 'Units',
      type: 'number',
    },
    country: {
      label: 'Export Country',
      type: 'string',
    },
  },
  getRowDisplayName: (row) => row.name,
  excludeKeys: ['semenId', 'id'],
};
